<template>
    <div class="success-job-application">
        <div class="success-icon">
            <div class="icon-container">
            <CheckCircleIcon class="check-icon"/>
            </div>
        </div>
        <div class="success-message">Your Application Was Sent Successfully!</div>

    </div>
</template>
<script>
import CheckCircleIcon from './IconComponents/CheckCircleIcon.vue';
export default{
    components:{
        CheckCircleIcon
    }
}
</script>
<style scoped>
    .success-message{
        font-family: var(--heading-font-bold);
        font-size:1.2rem;
        color:var(--page-header);
        display: flex;
        
    }

    .success-job-application{
        margin-bottom:3rem;
        margin-top:1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap:2rem;
    }

    .check-icon{
        height:6rem;
        width:6rem;
        color:var(--page-header);
    }

    .icon-container{
        display: flex;
        justify-content: center;
    }
</style>